import { render } from "./TestPage.vue?vue&type=template&id=3fa1d900&ts=true"
import script from "./TestPage.vue?vue&type=script&lang=ts"
export * from "./TestPage.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__